import { render, staticRenderFns } from "./InSwitchLED65Less.vue?vue&type=template&id=49b3d476&scoped=true&"
import script from "./InSwitchLED65Less.vue?vue&type=script&lang=js&"
export * from "./InSwitchLED65Less.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLED65Less.vue?vue&type=style&index=0&id=49b3d476&lang=scss&scoped=true&"
import style1 from "./InSwitchLED65Less.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3d476",
  null
  
)

export default component.exports